export default __webpack_public_path__ + "3b25382046ffbe0a1f49dd484a702ea0.png";